import { jsonInit } from '@shigo-ui/api-client';

import { createShigoApiClient, type ShigoApiConfig } from '../../../lib/shigo-api-client';
import { reportResponseSchema, type ReportRequest } from '../reportExplorer/model';

interface PerformanceAnalyzerClientOptions {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
}

export function createPerformanceAnalyzerClient({
  config,
  accessToken,
  fetcher,
}: PerformanceAnalyzerClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);
  const postReport = (path: string, request: ReportRequest) =>
    api.request({ path, schema: reportResponseSchema, init: jsonInit('POST', request) });
  return {
    run: (request: ReportRequest) => postReport('/api/report/ch', request),
    topStitcherPublishers: (request: ReportRequest) =>
      postReport('/api/report/ch/top10-stitching-pubs', request),
    stitcherPlacements: (request: ReportRequest) =>
      postReport('/api/report/ch/pub-stitching-placements', request),
  };
}
